(() => {
  const init = (root) => {
    if (!root || root.dataset.rdpReady === 'true') return;
    root.dataset.rdpReady = 'true';

    const mainImage = root.querySelector('.rdp-gallery__main-image');
    if (mainImage) {
      mainImage.draggable = false;
      mainImage.setAttribute('draggable', 'false');
      mainImage.addEventListener('dragstart', (event) => event.preventDefault());
    }
    const thumbs = [...root.querySelectorAll('[data-rdp-thumb]')];
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!mainImage) return;
        const src = thumb.dataset.imageSrc;
        if (src) {
          mainImage.src = src;
          mainImage.srcset = '';
        }
        thumbs.forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });

    const bundleButtons = [...root.querySelectorAll('[data-rdp-bundle]')];
    const price = root.querySelector('[data-rdp-price]');
    const mrp = root.querySelector('[data-rdp-mrp]');
    const saving = root.querySelector('[data-rdp-saving]');
    const variantInput = root.querySelector('[data-rdp-variant-id]');
    const form = root.querySelector('.rdp-product-form');
    const mainAdd = form ? form.querySelector('[name="add"]') : null;
    const buyNow = root.querySelector('[data-rdp-buy-now]');
    const sticky = root.querySelector('[data-rdp-sticky-atc]');
    const stickySelect = root.querySelector('[data-rdp-sticky-select]');
    const stickyPrice = root.querySelector('[data-rdp-sticky-price]');
    const stickyAdd = root.querySelector('[data-rdp-sticky-add]');
    const stickyImage = root.querySelector('[data-rdp-sticky-image]');

    const plainText = (value = '') => {
      const template = document.createElement('template');
      template.innerHTML = value;
      return (template.content.textContent || '').trim();
    };

    const getSavingsLabel = (button) => {
      if (!button) return '';

      const priceCents = Number(button.dataset.priceCents || 0);
      const compareCents = Number(button.dataset.compareCents || 0);

      if (!(priceCents > 0) || !(compareCents > priceCents)) return '';

      const percent = Math.round(((compareCents - priceCents) / compareCents) * 100);
      return percent > 0 ? `Save ${percent}% • Most Popular` : '';
    };

    const setVariant = (button, updateUrl = true) => {
      if (!button) return;
      const variantId = button.dataset.variantId;
      const available = button.dataset.available === 'true';

      bundleButtons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
        item.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      if (variantInput && variantId) variantInput.value = variantId;
      if (price && button.dataset.price) price.textContent = plainText(button.dataset.price);
      if (mrp) {
        mrp.textContent = plainText(button.dataset.compare || '');
        mrp.classList.toggle('is-hidden', !button.dataset.compare);
      }
      if (saving) {
        const savingsLabel = getSavingsLabel(button);
        saving.textContent = savingsLabel;
        saving.classList.toggle('is-hidden', !savingsLabel);
      }

      if (stickySelect && variantId) stickySelect.value = variantId;
      if (stickyPrice && button.dataset.price) stickyPrice.textContent = plainText(button.dataset.price);
      if (mainAdd) mainAdd.disabled = !available;
      if (buyNow) buyNow.disabled = !available;
      if (stickyAdd) stickyAdd.disabled = !available;

      const imageSrc = button.dataset.imageSrc;
      if (imageSrc) {
        if (mainImage) {
          mainImage.src = imageSrc;
          mainImage.srcset = '';
        }
        if (stickyImage) {
          stickyImage.src = imageSrc;
          stickyImage.srcset = '';
        }
      }

      if (updateUrl && variantId && window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
      }
    };

    bundleButtons.forEach((button) => {
      button.addEventListener('click', () => setVariant(button));
    });

    if (stickySelect) {
      stickySelect.addEventListener('change', () => {
        const button = bundleButtons.find((item) => item.dataset.variantId === stickySelect.value);
        setVariant(button);
      });
    }

    if (stickyAdd && form) {
      stickyAdd.addEventListener('click', () => {
        if (stickyAdd.disabled) return;
        if (mainAdd && typeof mainAdd.click === 'function') mainAdd.click();
        else form.requestSubmit();
      });
    }

    if (sticky) {
      const actions = root.querySelector('.rdp-actions');
      const updateSticky = () => {
        if (!actions) return;
        const rect = actions.getBoundingClientRect();

        // Keep the sticky ATC hidden while the original purchase actions
        // are still visible. Once they scroll above the viewport, keep the
        // sticky ATC visible for the remainder of the product page.
        const shouldShow = rect.bottom <= 0;

        sticky.classList.toggle('is-visible', shouldShow);
        sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      };
      updateSticky();
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky, { passive: true });
    }

    const pincodeRoot = root.querySelector('[data-rdp-pincode-root]');
    const pincode = root.querySelector('[data-rdp-pincode]');
    const pincodeButton = root.querySelector('[data-rdp-pincode-check]');
    const pincodeResult = root.querySelector('[data-rdp-pincode-result]');
    const resultCard = root.querySelector('[data-rdp-pincode-card]');
    const resultTitle = root.querySelector('[data-rdp-result-title]');
    const resultSubtitle = root.querySelector('[data-rdp-result-subtitle]');
    const resultPin = root.querySelector('[data-rdp-result-pin]');
    const resultArea = root.querySelector('[data-rdp-result-area]');
    const resultDistrict = root.querySelector('[data-rdp-result-district]');
    const resultState = root.querySelector('[data-rdp-result-state]');
    const resultOffices = root.querySelector('[data-rdp-result-offices]');

    const cleanPin = (value) => {
      const pin = String(value || '').replace(/\D/g, '').slice(0, 6);
      return /^[1-9]\d{5}$/.test(pin) ? pin : '';
    };

    const firstValue = (...values) => values.map((value) => String(value || '').trim()).find(Boolean) || '';
    const unique = (values) => [...new Set(values.map((value) => String(value || '').trim()).filter(Boolean))];

    const titleCase = (value) => {
      const text = String(value || '').trim();
      if (!text) return '—';
      return text.toLowerCase().replace(/\b\w/g, (letter) => letter.toUpperCase());
    };

    const setPincodeStatus = (message, isError = false) => {
      if (!pincodeResult) return;
      pincodeResult.textContent = message || '';
      pincodeResult.className = 'rdp-pincode__result';
      if (message) pincodeResult.classList.add(isError ? 'is-error' : 'is-success');
    };

    const setBusy = (button, busy, label = '') => {
      if (!button) return;
      if (!button.dataset.defaultLabel) button.dataset.defaultLabel = button.textContent.trim();
      button.disabled = Boolean(busy);
      button.setAttribute('aria-busy', busy ? 'true' : 'false');
      button.textContent = busy && label ? label : button.dataset.defaultLabel;
    };

    const hidePincodeCard = () => {
      if (resultCard) resultCard.hidden = true;
    };

    const renderPincodeCard = ({ title, subtitle, pin, area, district, state, offices = '' }) => {
      if (!resultCard) return;
      if (resultTitle) resultTitle.textContent = title || 'Delivery location found';
      if (resultSubtitle) resultSubtitle.textContent = subtitle || '';
      if (resultPin) resultPin.textContent = pin || '—';
      if (resultArea) resultArea.textContent = area || '—';
      if (resultDistrict) resultDistrict.textContent = district || '—';
      if (resultState) resultState.textContent = state || '—';
      if (resultOffices) resultOffices.textContent = offices || '';
      resultCard.hidden = false;
      setPincodeStatus('');
    };

    const normalisePostalRecords = (payload) => {
      if (Array.isArray(payload)) {
        if (payload.length && payload[0] && Array.isArray(payload[0].PostOffice)) return payload[0].PostOffice;
        return payload.filter((item) => item && typeof item === 'object');
      }
      if (payload && Array.isArray(payload.PostOffice)) return payload.PostOffice;
      if (payload && Array.isArray(payload.records)) return payload.records;
      return [];
    };

    const extractPostalData = (records) => {
      if (!Array.isArray(records) || !records.length) {
        return { area: '', district: '', state: '', offices: [], hasDeliveryOffice: false };
      }

      const deliveryRecord = records.find((item) => {
        const status = firstValue(item.Deliverystatus, item.DeliveryStatus, item.DeliveryStatusName).toLowerCase();
        return status === 'delivery';
      }) || records[0];

      return {
        area: firstValue(deliveryRecord.Name, deliveryRecord.officename, deliveryRecord.OfficeName, deliveryRecord.Block, deliveryRecord.Taluk, deliveryRecord.Division),
        district: firstValue(deliveryRecord.Districtname, deliveryRecord.District, deliveryRecord.district, deliveryRecord.Division),
        state: firstValue(deliveryRecord.statename, deliveryRecord.State, deliveryRecord.state, deliveryRecord.Circle),
        offices: unique(records.map((item) => firstValue(item.Name, item.officename, item.OfficeName))).slice(0, 4),
        hasDeliveryOffice: records.some((item) => {
          const status = firstValue(item.Deliverystatus, item.DeliveryStatus, item.DeliveryStatusName).toLowerCase();
          return status === 'delivery';
        })
      };
    };

    const fetchPostalRecords = async (pin) => {
      const encoded = encodeURIComponent(pin);
      const sources = [
        `https://cdn.jsdelivr.net/gh/IndiaPost/pin@master/api/v01/json/${encoded}.json`,
        `https://raw.githubusercontent.com/IndiaPost/pin/master/api/v01/json/${encoded}.json`,
        `https://api.postalpincode.in/pincode/${encoded}`
      ];

      for (const url of sources) {
        try {
          const response = await fetch(url, { method: 'GET', headers: { Accept: 'application/json' }, cache: 'no-store', mode: 'cors' });
          if (!response.ok) continue;
          const payload = await response.json();
          const records = normalisePostalRecords(payload);
          if (records.length) return records;
        } catch (error) {}
      }
      return [];
    };

    const lookupPincode = async (rawPin) => {
      const pin = cleanPin(rawPin);
      if (pincode) pincode.value = pin;

      if (!pin) {
        hidePincodeCard();
        setPincodeStatus('Enter a valid 6 digit Indian PIN code.', true);
        return;
      }

      setBusy(pincodeButton, true, 'CHECKING');
      hidePincodeCard();
      setPincodeStatus('Checking delivery location…');

      try {
        const records = await fetchPostalRecords(pin);
        if (!records.length) {
          renderPincodeCard({
            title: `PIN ${pin} entered`,
            subtitle: 'The PIN format is valid, but location details could not be loaded right now.',
            pin,
            area: '—',
            district: '—',
            state: pincodeRoot?.dataset.shopifyCountry || 'India'
          });
          setPincodeStatus('Location services are temporarily unavailable.', true);
          return;
        }

        const postal = extractPostalData(records);
        const parts = [titleCase(postal.area), titleCase(postal.district), titleCase(postal.state)].filter((value) => value !== '—');
        renderPincodeCard({
          title: parts.length ? `Delivering to ${parts.join(', ')}` : `PIN ${pin} found`,
          subtitle: postal.hasDeliveryOffice
            ? 'PIN verified with postal records. Delivery availability can now be checked for this location.'
            : 'PIN found in postal records.',
          pin,
          area: titleCase(postal.area),
          district: titleCase(postal.district),
          state: titleCase(postal.state),
          offices: postal.offices.length ? `Nearby post offices: ${postal.offices.join(', ')}.` : ''
        });
      } catch (error) {
        hidePincodeCard();
        setPincodeStatus('The PIN could not be checked right now. Please try again.', true);
      } finally {
        setBusy(pincodeButton, false);
      }
    };

    if (pincode && pincodeButton && pincodeResult) {
      pincode.addEventListener('input', () => {
        pincode.value = String(pincode.value || '').replace(/\D/g, '').slice(0, 6);
      });
      pincode.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          lookupPincode(pincode.value);
        }
      });
      pincodeButton.addEventListener('click', () => lookupPincode(pincode.value));
    }

    if (form && buyNow) {
      buyNow.addEventListener('click', async () => {
        if (mainAdd && mainAdd.disabled) return;
        try {
          const response = await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantInput.value), quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Cart add failed');
          window.location.href = '/checkout';
        } catch (error) {
          form.requestSubmit();
        }
      });
    }
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-rdp-section]').forEach(init);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
